import { FormikProps } from 'formik';
import { useFormContext } from '../../../../../contexts/FormContext';
import { Campaign } from '../../../../../types/Campaign.type';
import {
  BlogInput,
  MarketingIdeasInput,
  EmailInput,
  FormType,
  SocialInput,
  SocialPlatform,
} from '../../../../../types/FormTypes';
import { BasicInput } from '../../../../shared/inputs/BasicInput';

import styles from './CompanyNameWebsiteInputs.module.css';

type CompanyNameWebsiteInputsProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
  labelTitle?: string;
};

export function CompanyNameWebsiteInputs<
  T extends
    | BlogInput
    | SocialInput
    | EmailInput
    | MarketingIdeasInput
    | Campaign
>({
  formikProps,
  disabled,
  labelTitle = 'Basic information',
}: CompanyNameWebsiteInputsProps<T>) {
  const { formType, socialInput } = useFormContext();

  const getWebsitePlaceholderText = () => {
    if (formType === FormType.SOCIAL) {
      switch (socialInput?.platform) {
        case SocialPlatform.FACEBOOK:
          return 'Website or Facebook Profile URL (optional)';
        case SocialPlatform.INSTAGRAM:
          return 'Website or Instagram Profile URL (optional)';
        case SocialPlatform.TWITTER:
          return 'Website or Twitter Profile URL (optional)';
        case SocialPlatform.LINKEDIN:
          return 'Website or LinkedIn Profile URL (optional)';
      }
    }

    return 'Website (optional)';
  };

  return (
    <div className={styles['container']}>
      <label className={styles['label']}>
        <h2>{labelTitle}</h2>
        <p>
          Please provide the name of the company/product who is writing the
          copy.
        </p>
      </label>
      <div className={styles['inputs-container']}>
        <BasicInput
          id="companyName"
          label={<></>}
          placeholder="Company / Product name"
          value={formikProps.values.companyName}
          setValue={formikProps.handleChange('companyName')}
          disabled={disabled}
          errors={formikProps.errors.companyName as string}
          touched={formikProps.touched.companyName ? true : false}
          onBlur={formikProps.handleBlur}
        />
        <BasicInput
          id="companyWebsite"
          label={<></>}
          placeholder={getWebsitePlaceholderText()}
          value={formikProps.values.companyWebsite}
          setValue={formikProps.handleChange('companyWebsite')}
          disabled={disabled}
          errors={formikProps.errors.companyWebsite as string}
          touched={formikProps.touched.companyWebsite ? true : false}
          onBlur={formikProps.handleBlur}
        />
      </div>
    </div>
  );
}
